import React from 'react'
import { useLocation } from 'react-router'
import { SignUpForm } from './components/sign-up-form/SignUpForm'
import { EmailSent } from './components/email-sent/EmailSent'

export const SignUpView = () => {
  const location = useLocation()

  const { email, isEmailSent } = (location.state || {}) as {
    email?: string
    isEmailSent?: boolean
  }

  if (isEmailSent) {
    return <EmailSent email={email} />
  }

  return <SignUpForm />
}
